export default __webpack_public_path__ + "static/footer-icon-0a0d4651fbda5a1fce2d41254031c160.gif";